import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import CompleteChanger from './CompleteChanger'
import LocationSelector from './LocationSelector'
import Mover from './Mover'
import CommentChanger from './CommentChanger'
import { changeTeamComment, getAdminInitData } from '../../actions'

class Teams extends Component {
  constructor (props) {
    super(props)

    this.state = {
      showChanger: {},
      showCommentChanger: {},
      showMover: {},
      search: '',
      sortByStatus: false,
      location: ''
    }

    this.switchCompleteChanger = this.switchCompleteChanger.bind(this)
    this.switchCommentChanger = this.switchCommentChanger.bind(this)
    this.switchMover = this.switchMover.bind(this)
    this.changeLocation = this.changeLocation.bind(this)
    this.changeComment = this.changeComment.bind(this)
  }

  componentDidMount () {
    this.props.location && this.setState({ location: this.props.location })
  }

  componentWillReceiveProps (nextProps) {
    const excludedTeams = this.props.teams.filter(t => !nextProps.teams.includes(t))
    if (excludedTeams.length === 1) {
      let cloneObj = { ...this.state.showMover }
      cloneObj[excludedTeams[0].id] = false
      this.setState({ showMover: cloneObj })
    }
  }

  changeLocation (city) {
    this.setState({ location: city })
    this.props.dispatch(getAdminInitData(city))
  }

  changeComment (data) {
    this.props.dispatch(changeTeamComment(data))
  }

  switchCompleteChanger (id) {
    let cloneObj = { ...this.state.showChanger }
    cloneObj[id] = !cloneObj[id]
    this.setState({ showChanger: cloneObj })
  }

  switchCommentChanger (id) {
    let cloneObj = { ...this.state.showCommentChanger }
    cloneObj[id] = !cloneObj[id]
    this.setState({ showCommentChanger: cloneObj })
  }

  switchMover (id) {
    let cloneObj = { ...this.state.showMover }
    cloneObj[id] = !cloneObj[id]
    this.setState({ showMover: cloneObj })
  }

  compare (a, b) {
    a = a.toString().toLowerCase()
    b = b.toString().toLowerCase()
    if (a > b) return 1
    if (a < b) return -1
    return 0
  }

  render () {
    let { teams } = this.props
    teams = teams.filter(t => t.name.toLowerCase().includes(this.state.search.toLocaleLowerCase()))
    teams = this.state.sortByStatus
      ? teams
        .sort((a, b) => this.compare(b.complete, a.complete) ||
          this.compare(a.name, b.name))
      : teams

    return (
      <div className='main-col-cell' style={{ maxHeight: 'none' }}>
        <div className='dashboard-teams'>
          <div className='headline'>
            <h4 className='title-items'>
              Teams
              <LocationSelector location={this.state.location} changeLocation={this.changeLocation} />
              <div>
                <input
                  type='text'
                  className='search-input'
                  placeholder='search by name'
                  value={this.state.search}
                  onChange={ev => this.setState({ search: ev.target.value })} />
              </div>
            </h4>
            <div className='teams-header'>
              <div className='admin-tab-cell-name'>
                <span
                  onClick={() => this.setState({ sortByStatus: false })}
                  className='cursor-pointer'>⬇ Name</span>
              </div>
              <div className='cell-tags'>Players</div>
              <div className='cell-looking-for' style={{ minWidth: '50px' }}>
                <span
                  onClick={() => this.setState({ sortByStatus: !this.state.sortByStatus })}
                  className='cursor-pointer'>⬇ Complete</span>
              </div>
              <div style={{ minWidth: '170px' }} />
              {/* <div className='cell-looking-for' /> */}
              {/* <div className='cell-looking-for' /> */}
              {/* <div className='cell-looking-for' /> */}
            </div>
          </div>
          <div className='y-scroll-wrap'>
            <div className='y-scroll'>
              <div className='dashboard-teams-list'>
                {teams && teams.map(team => (
                  <div
                    key={team.id}
                    className='dashboard-teams-row'>
                    <div className='cell-name'
                      style={{ background: `url(${team.avatar || '/imgs/default-avatar.png'}) no-repeat center /cover` }} />
                    <div className='cell-subject'>
                      <Link to={`/team/${team.id}`} className='color-inherit'>
                        {team.name}
                      </Link>
                    </div>
                    <div className='cell-tags cell-looking-for'>
                      {team.participants.length}
                    </div>
                    <div className='cell-looking-for'>
                      {team.complete ? 'Yes' : 'No'}
                    </div>
                    <div className='cell-team cell-team-admin admin-tab-cell'>
                      <button
                        className='button button-sm'
                        onClick={() => this.switchCompleteChanger(team.id)}>Change</button>
                      {this.state.showChanger[team.id] && <CompleteChanger {...team} close={this.switchCompleteChanger} />}
                    </div>
                    <div className='cell-team cell-team-admin admin-tab-cell'>
                      <button
                        className='button button-sm'
                        onClick={() => this.switchCommentChanger(team.id)}>Comment</button>
                      {this.state.showCommentChanger[team.id] && <CommentChanger
                        {...team}
                        changeComment={this.changeComment}
                        close={this.switchCommentChanger} />}
                    </div>
                    <div className='cell-team cell-team-admin admin-tab-cell'>
                      <button
                        className='button button-sm'
                        onClick={() => this.switchMover(team.id)}>Move</button>
                      {this.state.showMover[team.id] &&
                        <Mover
                          {...team}
                          close={this.switchMover}
                          location={this.state.location} />}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div >
    )
  }
}

const mapStateToProps = (state) => {
  return {
    teams: state.team.teams,
    myTeam: state.team.myTeam,
    isAuthenticated: state.auth.isAuthenticated,
    location: state.auth.user.location
  }
}

export default connect(mapStateToProps)(Teams)



// WEBPACK FOOTER //
// ./src/screens/administration/Teams.js